import React, { Component } from 'react';
import MediaSearch from '../MediaSearch/MediaSearch';
import * as api from '../api';

export class Search extends React.Component {
	render() {
		return <MediaSearch {...this.props} search={api.search} />;
	}
}
